import FunsTree from './src/main.js';

/* istanbul ignore next */
FunsTree.install = function(Vue) {
  Vue.component(FunsTree.name, FunsTree);
};

export default FunsTree;
